module.exports = __webpack_public_path__ + "static/media/no-deliveries-1.c6000694.mp3";